import { render } from "./HeroSectionTwo.vue?vue&type=template&id=2d2f7bb6"
import script from "./HeroSectionTwo.vue?vue&type=script&lang=js"
export * from "./HeroSectionTwo.vue?vue&type=script&lang=js"

import "./HeroSectionTwo.vue?vue&type=style&index=0&id=2d2f7bb6&lang=css"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__